module.exports = __webpack_public_path__ + "img/atom-02.068f7fd5.svg";